import { deleteObject, getDownloadURL, ref, uploadBytes } from 'firebase/storage';
import { storage } from '../firebase/config';

const MAX_IMAGE_SIZE_BYTES = 5 * 1024 * 1024;
const ALLOWED_IMAGE_TYPES = new Set(['image/jpeg', 'image/png', 'image/webp']);

const getFileExtension = (file: File): string => {
  const fileNameExtension = file.name.split('.').pop()?.toLowerCase();
  if (fileNameExtension) {
    return fileNameExtension;
  }

  if (file.type === 'image/png') return 'png';
  if (file.type === 'image/webp') return 'webp';
  return 'jpg';
};

const buildMenuItemImagePath = (tenantId: string, menuItemId: string, extension: string): string => {
  return `tenants/${tenantId}/menuItems/${menuItemId}/cover-${Date.now()}.${extension}`;
};

export const validateMenuItemImage = (file: File): string | null => {
  if (!ALLOWED_IMAGE_TYPES.has(file.type)) {
    return 'Only JPG, PNG, and WEBP images are supported.';
  }

  if (file.size > MAX_IMAGE_SIZE_BYTES) {
    return 'Image size must be 5MB or smaller.';
  }

  return null;
};

export const uploadMenuItemImage = async (
  tenantId: string,
  menuItemId: string,
  file: File
): Promise<string> => {
  const extension = getFileExtension(file);
  const imageRef = ref(storage, buildMenuItemImagePath(tenantId, menuItemId, extension));
  await uploadBytes(imageRef, file);
  return getDownloadURL(imageRef);
};

export const deleteMenuItemImageByUrl = async (imageUrl?: string): Promise<void> => {
  if (!imageUrl) {
    return;
  }

  // Skip deletion for non-Firebase URLs.
  if (!imageUrl.includes('firebasestorage.googleapis.com') && !imageUrl.includes('firebasestorage.app')) {
    return;
  }

  try {
    await deleteObject(ref(storage, imageUrl));
  } catch (error) {
    // Ignore missing object errors to keep image replacement resilient.
    console.warn('Failed to delete previous menu item image:', error);
  }
};
